// extracted by mini-css-extract-plugin
export var root = "B1JB";
export var rootIcon = "iAWW";
export var rootImage = "J-O1";